// extracted by mini-css-extract-plugin
export default {"row":"players_row__0xqdW"};